import {valueSchema, validationSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'number_of_male_trainees_apprentices_intern_workers'

export const dataPointDefinition = {
  retracedId: 'number_of_male_trainees_apprentices_intern_workers',
  name: 'Number of male workers who are trainees, apprentices or interns:',
  description:
    'Apprenticeship refers to a period of time in which individuals (apprentices) receive in depth on the job training for a trade or craft from person(s) that are highly skilled in that particular trade or craft. Government-driven apprenticeship programs, if applicable, are included in scope. \r\r\n\r\r\nThe most significant differences between apprenticeships and trainee programs tend to be the time period involved. Apprenticeships tend to be longer (i.e. years) and trainee programs shorter (i.e. months). \r\r\n\r\r\nTrainee program refers to a period of time in which knowledge and/or skills needed for proficiency within a job or activity are provided to workers. Programs may be for new, unskilled workers or for existing workers to upgrade their skills. Probationary periods are covered separately and should not be recorded here.\r\r\n\r\r\nInternship programs are work experience offered by the facility for a limited period of time, and typically are arranged for those interested in joining a certain profession (meaning field of work) or those that have already joined a profession, but are at the beginning stages. \r\r\nIn some cases, internships are school-linked programs, whereby interns might earn school credit.\r\r\n\r\r\nApplicable legislation may have specific definitions for these types of work arrangements. If legal definitions exist, follow those definitions to determine your answer.',
  meta: {
    rangeValidation: true,
    optionalRange: true,
  },
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-wor-21',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 1580,
  sectionId: '2.2.6.2',
  impactArea: 'Worker Demographics (Languages and Nationalities)',
  impactAreaId: 'WORKER_DEMOGRAPHICS',
}

export const validateSchema = async (data, {validatorFn}) => {
  try {
    validate({value: data, schema: valueSchema})

    if (!validatorFn) {
      return data
    }

    if (validatorFn && typeof validatorFn !== 'function') {
      throw new Error(`expect range limits function to be a function, got ${typeof validatorFn}`)
    }

    const {value} = data

    const rangeValues = await validatorFn()
    validate({value: rangeValues, schema: validationSchema})

    const {min, max} = rangeValues
    if (min && value < min) {
      throw new Error('data mismatch, value is less than minimum allowed value')
    }

    if (max && value > max) {
      throw new Error('data mismatch, value is greater than maximum allowed value')
    }

    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
